import { render, staticRenderFns } from "./ManutencaoForm.vue?vue&type=template&id=2acdf5b5&scoped=true&"
import script from "./ManutencaoForm.vue?vue&type=script&lang=js&"
export * from "./ManutencaoForm.vue?vue&type=script&lang=js&"
import style0 from "./ManutencaoForm.vue?vue&type=style&index=0&id=2acdf5b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acdf5b5",
  null
  
)

export default component.exports